const URL_PATTERN = /(https?:\/\/[^\s<]+)/g;

function isUrl(value) {
  return /^https?:\/\//.test(value);
}

/**
 * Multi-line task instructions, with URLs left clickable.
 * @param {{ text?: string | null }} props
 */
export function TaskDetailsText({ text }) {
  const value = text?.trim();
  if (!value) return null;

  const parts = value.split(URL_PATTERN);

  return (
    <p className="task-details muted small">
      {parts.map((part, index) =>
        isUrl(part) ? (
          <a key={index} href={part} target="_blank" rel="noreferrer">
            {part}
          </a>
        ) : (
          <span key={index}>{part}</span>
        ),
      )}
    </p>
  );
}
